(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[12358],{

/***/ 53325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ClinicalTrialsContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53276);
/* harmony import */ var _components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66405);
/* harmony import */ var _b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63305);
/* harmony import */ var _b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88023);
/* harmony import */ var _b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4130);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88737);



// Main general category shared components



// images and icons

// category data
const imgTextComponentContent = {
    img: "/severalbrands/assets/images/clinicalTrial.webp",
    mainTitle: "Optimizing Clinical Trial Recruitment with Targeted Marketing",
    paragraphs: [
        "Clinical trials are vital for advancing medical research, yet recruitment remains a significant hurdle, with 80% of trials facing delays due to participant enrollment challenges. As a lead generation company specializing in clinical trial recruitment, we understand the importance of connecting you with the right participants. Our compassionate approach ensures that potential participants are well-informed and supported throughout the process, fostering trust and engagement.",
        "We leverage advanced data analytics and targeted outreach strategies to reach diverse patient populations effectively. Our expertise in recruitment allows you to focus on your trial objectives while we handle the complexities of participant engagement. Let us help you overcome recruitment challenges and enhance your clinical trials. Contact us now to discover how our tailored solutions can drive your research success.", 
    ],
    showAnimation: true,
    showButton: true,
    buttonTitle: "Schedule a Call"
};
const howWeWorkContent = {
    title: "Our Approach",
    list: [
        {
            title: "Collaborative Strategy Development",
            description: "We team up with your business to formulate a pricing strategy that aligns with your performance goals and fulfills your specific needs."
        },
        {
            title: "Custom Campaign Creation",
            description: "By conducting in-depth research, we craft targeted campaigns that reach genuine customers throughout the United States looking for clinical trials to participate in. Thus, we optimize our approach for maximum conversion."
        },
        {
            title: "Advanced Lead Verification",
            description: "We use advanced verification to ensure high-quality leads and reduce fraud and duplicates. Verified leads are sent to your intake center or ours, securing signed acquisitions for you."
        },
        {
            title: "Performance Feedback Loop",
            description: "We actively seek feedback on lead effectiveness through regular performance reports, allowing us to refine our strategies and continuously enhance lead quality to connect you with your ideal clientele."
        },
        {
            title: "KPI-Driven Success",
            description: "In collaboration with our partners, we establish clear Key Performance Indicators (KPIs) to measure cost-effectiveness and adjust compensation based on the achievement of these benchmarks."
        },
        {
            title: "Ongoing Optimization",
            description: "We cyclically refine steps 2 through 4, aiming for a seamless process that consistently meets our shared KPIs and drives mutual satisfaction and success."
        }, 
    ]
};
const partnerWitUSData = {
    title: "Why Partner With Us?",
    paragraphs: [
        {
            text: "Partnering with us means accessing a team of experts dedicated to your success. Our data-driven approach ensures that every marketing effort resonates with your target audience, driving measurable results and sustainable growth. We help you connect with the right clinical trial participants quickly and efficiently, accelerating your trials and moving your research forward with confidence.",
            className: "default"
        },
        {
            text: "Let us help you unlock your full potential and accelerate success in the medical field. Together, we can transform your marketing strategy into a powerful tool, ensuring that your clinical trials quickly reach the right audiences, so life-saving medicines get to those who need them faster.",
            className: "default"
        }, 
    ],
    buttonText: "Partner With Us"
};
const unlockBusinessContent = [
    {
        img: "/severalbrands/assets/images/unlockBusinessSuccessB2b2.webp",
        mainTitle: "Enhance Participant Recruitment with Diverse Marketing Approaches",
        secondTitle: "SEO & SEM",
        paragraphs: [
            "SEO provides sustainable growth at no extra cost but might not scale quickly. To accelerate our client's growth, we integrate SEM tactics. This strategy includes a specialized team for SEO content development and a robust team of over 20 SEM professionals managing paid campaigns across Google, Bing, and Yahoo. This dual approach ensures our digital marketing efforts are both effective and comprehensive.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] `,
        mainTitleClassName: "text-[#351C4F]",
        secondTitleClassName: "mt-[20px] text-[#37367D]",
        imgClassName: "w-[250px]  h-[250px] md:w-[420px] md:min-w-[420px] md:h-[420px] relative 3xl:w-[620px] 3xl:min-w-[620px] 3xl:h-[620px] lg:mt-10 lg:ml-16 3xl:ml-28"
    },
    {
        img: "/severalbrands/assets/images/displayAdvertisingB2b.png",
        mainTitle: "Innovative Display Advertising",
        paragraphs: [
            "Our display advertising strategy employs a variety of platforms, incorporating the Google Display Network, native advertising with Taboola and Outbrain, PPV campaigns, and other external networks. With more than ten years in the field, we have honed our techniques to optimize conversion rates and deliver superior campaign performance consistently.", 
        ],
        mainSectionClassName: `lg:gap-[160px] gap-[40px] lg:ml-16 3xl:ml-28 `,
        mainTitleClassName: "text-[#37367D] 3xl:mt-[60px]",
        imgToLeft: true,
        imgClassName: "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]"
    },
    {
        img: "/severalbrands/assets/images/localizationB2b2.webp",
        mainTitle: "Strategic Localization",
        paragraphs: [
            "Localization is crucial for effectively reaching multilingual audiences in clinical trials. Trials targeting both English and Spanish speakers can significantly enhance recruitment and engagement by adopting this strategy.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[180px]  gap-[40px]  `,
        secondSectionClassName: "",
        mainTitleClassName: "text-[#37367D] lg:mt-10",
        imgClassName: "w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative lg:ml-16 3xl:ml-28"
    }, 
];
function ClinicalTrialsContainer() {
    const { category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_6__/* .useDomainContext */ .w)();
    const description = category?.metatags?.find((meta)=>meta.key === "description")?.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: category?.title ?? "Accelerate Clinical Trial Recruitment with Digital Marketing | SeveralBrands.com",
                description: description ?? "Boost your clinical trial recruitment with Several Brands' targeted digital marketing solutions. Efficient, cost-effective participant engagement starts here."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                mainData: {
                    imgTextComponentContent: imgTextComponentContent,
                    hideStrategicLeadGenerationContent: true
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                mainData: {
                    howWeWorkContent: howWeWorkContent,
                    hideHowWeWorkContent: true
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                mainData: {
                    partnerWithUSData: partnerWitUSData,
                    unlockBusinessContent: unlockBusinessContent
                }
            })
        ]
    });
}


/***/ }),

/***/ 53612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DebtReliefContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53276);
/* harmony import */ var _components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66405);
/* harmony import */ var _b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63305);
/* harmony import */ var _b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88023);
/* harmony import */ var _b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4130);
/* harmony import */ var _b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69508);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73760);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59591);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(587);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59535);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83873);
/* harmony import */ var _components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(44444);
/* harmony import */ var _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63644);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88737);



// Main general category shared components



// images and icons









// category data
const imgTextComponentContent = {
    img: "/severalbrands/assets/images/debtRelief.webp",
    mainTitle: "Amplify Your Debt Relief Leads",
    paragraphs: [
        "According to Market Research Future, the debt relief market is set to grow significantly in the coming years, driven by the rising need for financial solutions that address consumer debt challenges. As individuals and businesses seek effective ways to manage and reduce their debt, there is an increasing demand for services that offer personalized solutions, transparency, and financial education.",
        "Thriving in the debt relief industry requires strategic marketing to connect with customers seeking trusted financial assistance. Our customized marketing strategies are designed to help you reach more people, build trust, and significantly impact the debt relief industry. Fill out the form above to schedule a call with us and learn how we can work together to turn your business potential into lasting success.", 
    ],
    showAnimation: true,
    showButton: true,
    buttonTitle: "Request a Call"
};
const strategicLeadGenerationContent = {
    title: "Strategic Lead Generation: Timing Meets Precision",
    topDescription: "Our prowess in spearheading lead-generation efforts across diverse industries stems from our unique approach.",
    bottomDescription: "Outsourcing your lead generation isn't just a time saver—it's a cost-effective strategy to boost your business's growth. Partner with us for unparalleled lead generation expertise, allowing you to concentrate on perfecting your offerings and achieving outstanding results for your clients.",
    list: [
        {
            title: "B2B Lead Cultivation",
            tabName: "B2B",
            slug: "b2b",
            description: "A shocking finding by Marketing Donut reveals that 80% of leads go unexplored, resulting in a wide expanse of lost opportunities. Our advanced methods and systems are designed to identify and cultivate genuine leads, ensuring every potential client is engaged through follow-up messages or direct calls. This approach positions us to deliver high-quality prospects to your business, enhancing customer loyalty. We have vast experience working with a wide range of industries and helping your company to serve other businesses.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection_strategicLeadGeneration_icons_b2bLeadCultivationIcon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeHelpContent = {
    mainTitle: "How We Help Your Business Attract More Customers",
    list: [
        {
            title: "Cost Per Click",
            p: "Our comparison and review websites can drive highly qualified traffic to your offer.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerClickIcon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Sale",
            p: "Our revenue model is sales-oriented, ensuring we are compensated solely upon delivering tangible sales outcomes for your business.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerSaleIcon__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Lead",
            p: "We excel at generating top-notch web form leads using targeted paid search, social media, display ads, organic SEO, and other advertising campaigns.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerLeadIcon__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {})
        },
        {
            title: "Cost Per Call",
            p: "We assist local businesses in boosting their customer calls through our billable call service. We only charge for calls that either meet a set duration threshold or result in a conversion.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerCallIcon__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
        },
        {
            title: "Performance-Based Cost Structure",
            p: "Law firms can partner with us risk-free. Payment is contingent on signing the retainer, handled by either your intake team or our reliable intake center.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_costPerRetainerIcon__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
        },
        {
            title: "Revenue Share",
            p: "Under this model, we produce top-tier leads for your business, and you compensate us solely based on a percentage of the revenue derived from those leads.",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_howWeWorkPage_partneringWithSeveralBrands_icons_revenueShareIcon__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {})
        }, 
    ]
};
const howWeWorkContent = {
    title: "How We Work",
    list: [
        {
            description: "Our company works with your business to create a pricing strategy that aligns with your performance metrics and meets your requirements."
        },
        {
            description: "Our team conducts thorough research to generate leads tailored to your specific needs and ideal customer profile (ICP). We then create personalized campaigns targeting actual customers through comprehensive research to maximize conversions."
        },
        {
            description: "Our advanced lead verification system filters out fraud, checks syntax, and flags duplicates. Verified leads are nurtured by our call center team, using keyword optimization and strategic timing to boost conversions. Each lead is verified before being promptly sent to you."
        },
        {
            description: "We request regular reports from our clients on lead performance, including contact status and sales conversion rates. This helps us to improve lead quality and find the perfect customers for our clients."
        },
        {
            description: "We agree on KPIs with our partners for a reasonable cost per sale or opportunity and adjust payouts based on performance against these KPIs."
        },
        {
            description: "Continue following steps 2, 3, and 4 until we achieve an autopilot mode that meets our business's KPIs and satisfies everyone involved."
        }, 
    ]
};
const unlockBusinessContent = [
    {
        img: "/severalbrands/assets/images/unlockBusinessSuccessB2b2.webp",
        mainTitle: "Unlock Business Success With Diverse Marketing Channels & Tactics",
        secondTitle: "SEO & SEM",
        paragraphs: [
            "While SEO offers lasting benefits and revenue growth without added expenses, it may lack scalability. To ramp up sales for our clients, we employ SEM. Our approach involves a dedicated content creation team for SEO and more than 20 SEM account managers overseeing paid media campaigns across Google, Bing, and Yahoo, guaranteeing effective and efficient digital marketing solutions.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] `,
        mainTitleClassName: "text-[#351C4F]",
        secondTitleClassName: "mt-[20px] text-[#37367D]",
        imgClassName: "w-[250px]  h-[250px] md:w-[420px] md:min-w-[420px] md:h-[420px] relative 3xl:w-[620px] 3xl:min-w-[620px] 3xl:h-[620px] lg:mt-10 lg:ml-16 3xl:ml-28"
    },
    {
        img: "/severalbrands/assets/images/displayAdvertisingB2b.png",
        mainTitle: "Display Advertising",
        paragraphs: [
            "We implement diverse sources in our display advertising strategies, leveraging platforms like the Google Display Network, native advertising channels such as Taboola and Outbrain, PPV advertising, and other third-party networks. With over a decade of experience, we've rigorously tested and refined our methods across these networks to deliver top-notch quality and maximize conversion metrics for our advertising campaigns.", 
        ],
        mainSectionClassName: `lg:gap-[160px] gap-[40px] lg:ml-16 3xl:ml-28 `,
        mainTitleClassName: "text-[#37367D] 3xl:mt-[60px]",
        imgToLeft: true,
        imgClassName: "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]"
    },
    {
        img: "/severalbrands/assets/images/localizationB2b2.webp",
        mainTitle: "Localization",
        paragraphs: [
            "Localization is a potent marketing tool, particularly for clients with global outreach or diverse language audiences. US-based law firms aiming at English- and Spanish-speaking clientele can gain substantial advantages. Likewise, software companies offering antivirus, website builders, hosting services, etc., can leverage localization to enhance both paid media and organic traffic.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[180px]  gap-[40px]  `,
        secondSectionClassName: "",
        mainTitleClassName: "text-[#37367D] lg:mt-10",
        imgClassName: "w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative lg:ml-16 3xl:ml-28"
    }, 
];
function DebtReliefContainer() {
    const { category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_14__/* .useDomainContext */ .w)();
    const description = category?.metatags?.find((meta)=>meta.key === "description")?.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: category?.title ?? "Connect with Clients in Need of Debt Relief Solutions | SeveralBrands.com",
                description: description ?? "Explore how Several Brands' expert lead generation strategies can enhance your debt relief business funnel. Fill out the form to connect today."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                mainData: {
                    imgTextComponentContent: imgTextComponentContent,
                    strategicLeadGenerationContent: strategicLeadGenerationContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                mainData: {
                    howWeHelpContent: howWeHelpContent,
                    howWeWorkContent: howWeWorkContent
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                mainData: {
                    partnerWithUSData: _components_severalbrands_homePage_forthSection__WEBPACK_IMPORTED_MODULE_13__/* .partnerWitUSData */ .D,
                    unlockBusinessContent: unlockBusinessContent
                }
            })
        ]
    });
}


/***/ }),

/***/ 62715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SeveralBrandsCategoryPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88737);
/* harmony import */ var _components_severalbrands_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54531);
/* harmony import */ var _components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66405);
/* harmony import */ var _components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53276);
/* harmony import */ var _components_severalbrands_b2b_thirdSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88023);
/* harmony import */ var _components_severalbrands_b2b_forthSection__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4130);
/* harmony import */ var _components_severalbrands_logoSlider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93549);









function SeveralBrandsCategoryPage() {
    const { domain , category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_1__/* .useDomainContext */ .w)();
    const finalLogos = (0,_components_severalbrands_utils__WEBPACK_IMPORTED_MODULE_2__/* .getFinalLogosForLogoSLider */ .fH)(domain.config?.sliderLogos, null);
    const description = category?.metatags?.find((meta)=>meta.key === "description")?.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                title: category?.title ?? "Unleash Your Business's Growth Potential | SeveralBrands.com",
                description: description ?? "Discover how our expert lead generation tactics can supercharge your sales funnel. Book your consultation today!",
                keyWords: (0,_components_severalbrands_utils__WEBPACK_IMPORTED_MODULE_2__/* .getKeyWordsForMetaTags */ .U8)(domain)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
            finalLogos?.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_logoSlider__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                logos: finalLogos
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_b2b_thirdSection__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_b2b_forthSection__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
        ]
    });
}


/***/ }),

/***/ 44372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HighEndRehabContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53276);
/* harmony import */ var _components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66405);
/* harmony import */ var _b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63305);
/* harmony import */ var _b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88023);
/* harmony import */ var _b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4130);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88737);



// Main general category shared components



// images and icons

// category data
const imgTextComponentContent = {
    img: "/severalbrands/assets/images/rehab.webp",
    mainTitle: "Maximizing Patient Acquisition in a Competitive Market",
    paragraphs: [
        "High-end drug, alcohol, and mental health rehab centers face unique challenges in client acquisition due to their specialized services and exclusive clientele. We connect premium services with high-intent clients, enhancing admissions and fostering long-term recovery. Our tailored approach attracts leads seeking luxury rehab with personalized treatment options. By creating compelling content, landing pages, and advertisements, we attract and convert high-quality leads, ensuring those in need can access the right centers.",
        "We offer flexible pricing options, including cost-per-lead (CPL) and cost-per-acquisition (CPA) models, tailored to your needs. Whether you're a treatment provider or involved in lead aggregation for premium healthcare services, connect with us today to enhance your client acquisition strategies and achieve sustained growth.", 
    ],
    showAnimation: true,
    showButton: true,
    buttonTitle: "Schedule a Call"
};
const howWeWorkContent = {
    title: "Our Approach",
    list: [
        {
            title: "Collaborative Strategy Development",
            description: "We team up with your business to formulate a pricing strategy that aligns with your performance goals and fulfills your specific needs."
        },
        {
            title: "Custom Campaign Creation",
            description: "By conducting in-depth research, we craft targeted campaigns that reach genuine customers, throughout the United States, looking for treatment programs that address substance abuse, alcohol addiction, or mental health conditions. Thus, we optimize our approach for maximum conversion."
        },
        {
            title: "Advanced Lead Verification",
            description: "We use advanced verification to ensure high-quality leads and reduce fraud and duplicates. Verified leads are sent to your intake center or ours, securing signed acquisitions for you that have the appropriate health insurance or alternative payment options."
        },
        {
            title: "Performance Feedback Loop",
            description: "We actively seek feedback on lead effectiveness through regular performance reports, allowing us to refine our strategies and continuously enhance lead quality to connect you with your ideal clientele."
        },
        {
            title: "KPI-Driven Success",
            description: "In collaboration with our partners, we establish clear Key Performance Indicators (KPIs) to measure cost-effectiveness and adjust compensation based on the achievement of these benchmarks."
        },
        {
            title: "Ongoing Optimization",
            description: "We cyclically refine steps 2 through 4, aiming for a seamless process that consistently meets our shared KPIs and drives mutual satisfaction and success."
        }, 
    ]
};
const partnerWitUSData = {
    title: "Why Partner With Us?",
    paragraphs: [
        {
            text: "Partnering with us means accessing a team of experts dedicated to your success. Our data-driven approach ensures that every marketing effort reaches those seeking premium rehabilitation services, driving measurable results and sustainable growth. We help you connect with individuals in need of your specialized care, navigate the complexities of the healthcare market, and ensure your center stands out with confidence.",
            className: "default"
        },
        {
            text: "Let us help you unlock your center's full potential and thrive in this competitive field. Together, we can transform your outreach strategy into a powerful tool for success, ensuring that your services reach the clients who need them most.",
            className: "default"
        }, 
    ],
    buttonText: "Partner With Us"
};
const unlockBusinessContent = [
    {
        img: "/severalbrands/assets/images/unlockBusinessSuccessB2b2.webp",
        mainTitle: "Maximize Your Admissions with Multifaceted Marketing Strategies",
        secondTitle: "SEO & SEM",
        paragraphs: [
            "SEO provides sustainable growth at no extra cost but might not scale quickly. To accelerate our client's growth, we integrate SEM tactics. This strategy includes a specialized team for SEO content development and a robust team of over 20 SEM professionals managing paid campaigns across Google, Bing, and Yahoo. This dual approach ensures our digital marketing efforts are both effective and comprehensive.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] `,
        mainTitleClassName: "text-[#351C4F]",
        secondTitleClassName: "mt-[20px] text-[#37367D]",
        imgClassName: "w-[250px]  h-[250px] md:w-[420px] md:min-w-[420px] md:h-[420px] relative 3xl:w-[620px] 3xl:min-w-[620px] 3xl:h-[620px] lg:mt-10 lg:ml-16 3xl:ml-28"
    },
    {
        img: "/severalbrands/assets/images/displayAdvertisingB2b.png",
        mainTitle: "Innovative Display Advertising",
        paragraphs: [
            "Our display advertising strategy employs a variety of platforms, incorporating the Google Display Network, native advertising with Taboola and Outbrain, PPV campaigns, and other external networks. With more than ten years in the field, we have honed our techniques to optimize conversion rates and deliver superior campaign performance consistently.", 
        ],
        mainSectionClassName: `lg:gap-[160px] gap-[40px] lg:ml-16 3xl:ml-28 `,
        mainTitleClassName: "text-[#37367D] 3xl:mt-[60px]",
        imgToLeft: true,
        imgClassName: "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]"
    },
    {
        img: "/severalbrands/assets/images/localizationB2b2.webp",
        mainTitle: "Strategic Localization",
        paragraphs: [
            "Localization is a critical strategy for effectively reaching global markets or multilingual audiences. Luxury addiction treatment and alcohol rehab centers in the US that target both English and Spanish speakers can significantly benefit from this approach.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[180px]  gap-[40px]  `,
        secondSectionClassName: "",
        mainTitleClassName: "text-[#37367D] lg:mt-10",
        imgClassName: "w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative lg:ml-16 3xl:ml-28"
    }, 
];
function HighEndRehabContainer() {
    const { category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_6__/* .useDomainContext */ .w)();
    const description = category?.metatags?.find((meta)=>meta.key === "description")?.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: category?.title ?? "High-End Rehab Leads: Boost Your Client Admissions | SeveralBrands.com",
                description: description ?? "Discover how Several Brands can enhance your client acquisition for high-end rehab centers with targeted leads and effective marketing strategies."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                mainData: {
                    imgTextComponentContent: imgTextComponentContent,
                    hideStrategicLeadGenerationContent: true
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                mainData: {
                    howWeWorkContent: howWeWorkContent,
                    hideHowWeWorkContent: true
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                mainData: {
                    partnerWithUSData: partnerWitUSData,
                    unlockBusinessContent: unlockBusinessContent
                }
            })
        ]
    });
}


/***/ }),

/***/ 63644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ partnerWitUSData; },
/* harmony export */   "Z": function() { return /* binding */ ForthSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_severalbrands_homePage_firstSection_textImageSharedComponent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26784);
/* harmony import */ var _components_severalbrands_whyPartnerWithUs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64080);



const simplifyingComplexDecisions = {
    img: "/severalbrands/assets/images/wantLearnMore.webp",
    mainTitle: "Want to Learn More?",
    mainTitleClassName: "font-bold lg:text-[50px] text-[30px] lg:leading-10 text-[#351C4F] text-center lg:text-left",
    paragraphsClassName: "lg:mt-5  lg:text-[30px]  text-xl lg:leading-10 text-center lg:text-left font-light",
    paragraphs: [
        "Get our free guide, 10 Key Considerations Before Partnering With a Lead Generation Company.", 
    ],
    imgToLeft: true,
    showButton: true,
    showAnimation: true,
    guideButtonTitle: "Download for Free Now"
};
const partnerWitUSData = {
    title: "Why Partner With Us?",
    paragraphs: [
        {
            text: `At Several Brands, the businesses we work with are more than
                clients. They are key collaborators and partners. We only
                succeed if you succeed. When you partner with us, you can expect
                a comprehensive, end-to-end marketing solution that delivers
                results. From lead generation to performance marketing to
                analytics and reporting, we have the expertise to help your
                business succeed.`,
            className: "default"
        },
        {
            text: `Contact us today to learn more about how we can help you achieve
                your marketing goals.`,
            className: "mt-6  3xl:max-w-[1040px] 3xl:text-xl max-w-[740px]  font-light"
        }, 
    ],
    buttonText: "Partner With Us"
};
const partnerWitUSDataHomePage = {
    title: "Ready to Scale with Performance-Based Leads?",
    titleClassName: "max-w-[1040px] !leading-[normal]",
    paragraphs: [
        {
            text: `We tailor high-intent lead campaigns to your business development goals, using performance-based pricing rather than a flat rate. Ready to see what that looks like for your business?`,
            className: "default"
        }, 
    ],
    buttonText: "Get Your Free Consultation"
};
function ForthSection() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "lg:mb-52 mb-36 mt-16 lg:mt-0 ",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "lg:mb-20 lg:mt-28 ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_homePage_firstSection_textImageSharedComponent__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    info: simplifyingComplexDecisions
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-32 lg:mt-10 ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_whyPartnerWithUs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    partnerWitUSData: partnerWitUSDataHomePage
                })
            })
        ]
    });
}


/***/ }),

/***/ 93549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LogoSlider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32233);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76265);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71391);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_severalbrands_sharedButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81467);






function LogoSlider({ logos , animationDuration , showButton , mainTitle , buttonText  }) {
    const mainSectionDevRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: removeAnimationStyle , 1: setRemoveAnimationStyle  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const isInView = (0,framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .useInView */ .Y)(mainSectionDevRef, {
        once: true
    });
    const firstEl = (0,framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .useAnimation */ ._)();
    const finalLogos = logos;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const startAnimation = window.innerWidth < 767 ? finalLogos.length > 2 : finalLogos.length > 6;
        if (startAnimation) {
            setRemoveAnimationStyle(false);
            const mainScrolled = document.getElementById("mainSectionDevRef");
            if (mainScrolled) {
                mainScrolled.setAttribute("data-animated", "true");
            }
            const innerScrolled = document.getElementById("innerSectionDevRef");
            if (innerScrolled) {
                const innerScrolledContent = Array.from(innerScrolled.children);
                innerScrolledContent.forEach((item)=>{
                    const duplicatedItem = item.cloneNode(true);
                    innerScrolled.appendChild(duplicatedItem);
                });
            }
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isInView) {
            firstEl.start("visible").catch(()=>{});
        }
    }, [
        isInView
    ]);
    const outerSectionStyle = {
        "--animationDuration": `${animationDuration ? animationDuration : 40}s`
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .motion.section */ .E.section, {
        ref: mainSectionDevRef,
        id: "mainSectionDevRef",
        className: ` 3xl:mt-36 lg:mt-32 mt-24    relative  mx-auto ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_7___default().scrolled)}`,
        variants: {
            visible: {
                y: [
                    150,
                    0
                ],
                opacity: [
                    0,
                    1
                ],
                transition: {
                    duration: 1.5
                }
            }
        },
        animate: firstEl,
        style: outerSectionStyle,
        children: [
            !removeAnimationStyle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "hidden lg:block absolute inset-0 z-20 before:absolute before:left-0 before:top-0 before:w-1/4 before:h-full before:bg-gradient-to-r before:from-white before:to-transparent before:filter before:blur-3 after:absolute after:right-0 after:top-0 after:w-1/4 after:h-full after:bg-gradient-to-l after:from-white after:to-transparent after:filter after:blur-3"
            }) //the shadow on both sides on the slider
            ,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "relative z-30 font-bold 3xl:text-6xl lg:text-4xl text-2xl lg:leading-10 text-center ",
                children: mainTitle || "We Collaborate With 600+ Companies in Different Sectors"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "innerSectionDevRef",
                className: `mt-7 lg:mt-12  3xl:mt-20  3xl:h-[60px] lg:h-[45px] h-[29px] ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_7___default().scrolled__inner)} ${removeAnimationStyle ? "justify-center" : ""}`,
                children: finalLogos?.map((logo, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `w-[120px]  lg:w-[172px] 3xl:w-[250px] relative `,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative mx-auto w-[80%] h-[100%] block",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: logo.path,
                                alt: logo.slug,
                                layout: "fill",
                                objectFit: "contain",
                                loading: "eager"
                            })
                        })
                    }, index))
            }),
            showButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "z-30 relative 3xl:mt-20 mt-12 text-center w-fit mx-auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_sharedButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    href: "/partner-with-us",
                    children: buttonText || "Partner With Us"
                })
            })
        ]
    });
}


/***/ }),

/***/ 88655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TortsContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53276);
/* harmony import */ var _components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66405);
/* harmony import */ var _b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63305);
/* harmony import */ var _b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88023);
/* harmony import */ var _b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4130);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88737);



// Main general category shared components



// images and icons

// category data
const imgTextComponentContent = {
    img: "/severalbrands/assets/images/torts.webp",
    mainTitle: "Streamlining Client Acquisition for Mass Torts Lawyers",
    paragraphs: [
        "Mass torts attorneys face distinct hurdles in client acquisition, often navigating intricate cases that demand extensive resources and specialized legal knowledge. Balancing multiple cases, managing client expectations, and dealing with the complexities of mass tort litigation can strain even the most well-organized firms, making an efficient client intake strategy essential.",
        "Several Brands recognizes these challenges and offers tailored lead-generation solutions designed specifically for mass tort cases. We craft targeted, educational content and precision advertising that resonates with potential clients, ensuring your legal services reach those who need them most. By partnering with us, mass tort attorneys can streamline their client intake process, allowing them to focus on delivering high-quality legal representation while we handle the complexities of acquiring new clients.", 
    ],
    showAnimation: true
};
const howWeWorkContent = {
    title: "Our Approach",
    list: [
        {
            title: "Collaborative Strategy Development",
            description: "We team up with your business to formulate a pricing strategy that aligns with your performance goals and fulfills your specific needs."
        },
        {
            title: "Custom Campaign Creation",
            description: "By conducting in-depth research, we craft targeted campaigns that reach genuine customers throughout the United States looking for clinical trials to participate in. Thus, we optimize our approach for maximum conversion."
        },
        {
            title: "Advanced Lead Verification",
            description: "We use advanced verification to ensure high-quality leads and reduce fraud and duplicates. Verified leads are sent to your intake center or ours, securing signed acquisitions for you."
        },
        {
            title: "Performance Feedback Loop",
            description: "We actively seek feedback on lead effectiveness through regular performance reports, allowing us to refine our strategies and continuously enhance lead quality to connect you with your ideal clientele."
        },
        {
            title: "KPI-Driven Success",
            description: "In collaboration with our partners, we establish clear Key Performance Indicators (KPIs) to measure cost-effectiveness and adjust compensation based on the achievement of these benchmarks."
        },
        {
            title: "Ongoing Optimization",
            description: "We cyclically refine steps 2 through 4, aiming for a seamless process that consistently meets our shared KPIs and drives mutual satisfaction and success."
        }, 
    ]
};
const partnerWitUSData = {
    title: "Why Partner With Us?",
    paragraphs: [
        {
            text: "Partnering with us means accessing a team of experts dedicated to your success. Our data-driven approach ensures that every marketing effort resonates with your target audience, driving measurable results and sustainable growth. We help you connect with the right clinical trial participants quickly and efficiently, accelerating your trials and moving your research forward with confidence.",
            className: "default"
        },
        {
            text: "Let us help you unlock your full potential and accelerate success in the medical field. Together, we can transform your marketing strategy into a powerful tool, ensuring that your clinical trials quickly reach the right audiences, so life-saving medicines get to those who need them faster.",
            className: "default"
        }, 
    ],
    buttonText: "Partner With Us"
};
const unlockBusinessContent = [
    {
        img: "/severalbrands/assets/images/unlockBusinessSuccessB2b2.webp",
        mainTitle: "Enhance Participant Recruitment with Diverse Marketing Approaches",
        secondTitle: "SEO & SEM",
        paragraphs: [
            "SEO provides sustainable growth at no extra cost but might not scale quickly. To accelerate our client's growth, we integrate SEM tactics. This strategy includes a specialized team for SEO content development and a robust team of over 20 SEM professionals managing paid campaigns across Google, Bing, and Yahoo. This dual approach ensures our digital marketing efforts are both effective and comprehensive.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[130px] gap-[40px] `,
        mainTitleClassName: "text-[#351C4F]",
        secondTitleClassName: "mt-[20px] text-[#37367D]",
        imgClassName: "w-[250px]  h-[250px] md:w-[420px] md:min-w-[420px] md:h-[420px] relative 3xl:w-[620px] 3xl:min-w-[620px] 3xl:h-[620px] lg:mt-10 lg:ml-16 3xl:ml-28"
    },
    {
        img: "/severalbrands/assets/images/displayAdvertisingB2b.png",
        mainTitle: "Innovative Display Advertising",
        paragraphs: [
            "Our display advertising strategy employs a variety of platforms, incorporating the Google Display Network, native advertising with Taboola and Outbrain, PPV campaigns, and other external networks. With more than ten years in the field, we have honed our techniques to optimize conversion rates and deliver superior campaign performance consistently.", 
        ],
        mainSectionClassName: `lg:gap-[160px] gap-[40px] lg:ml-16 3xl:ml-28 `,
        mainTitleClassName: "text-[#37367D] 3xl:mt-[60px]",
        imgToLeft: true,
        imgClassName: "w-[250px]  h-[200px] md:w-[458px] md:min-w-[458px] md:h-[312px] relative 3xl:w-[630px] 3xl:min-w-[630px] 3xl:h-[554px]"
    },
    {
        img: "/severalbrands/assets/images/localizationB2b2.webp",
        mainTitle: "Strategic Localization",
        paragraphs: [
            "Localization is crucial for effectively reaching multilingual audiences in clinical trials. Trials targeting both English and Spanish speakers can significantly enhance recruitment and engagement by adopting this strategy.", 
        ],
        mainSectionClassName: `3xl:gap-[200px] lg:gap-[180px]  gap-[40px]  `,
        secondSectionClassName: "",
        mainTitleClassName: "text-[#37367D] lg:mt-10",
        imgClassName: "w-[250px]  h-[250px] md:w-[392px] md:min-w-[392px] md:h-[392px] 3xl:w-[592px] 3xl:min-w-[592px] 3xl:h-[592px]  relative lg:ml-16 3xl:ml-28"
    }, 
];
function TortsContainer() {
    const { category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_6__/* .useDomainContext */ .w)();
    const description = category?.metatags?.find((meta)=>meta.key === "description")?.value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_metaTags__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: category?.title ?? "Supercharge Your Firm's Mass Tort Intake | SeveralBrands.com",
                description: description ?? "Boost your practice with our targeted mass tort lead generation. Fill out the form to schedule a call and learn how we can help drive your success."
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_HeroSection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_secondSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                mainData: {
                    imgTextComponentContent: imgTextComponentContent,
                    hideStrategicLeadGenerationContent: true
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_thirdSection__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                mainData: {
                    howWeWorkContent: howWeWorkContent,
                    hideHowWeWorkContent: true
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_b2b_forthSection__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                mainData: {
                    partnerWithUSData: partnerWitUSData,
                    unlockBusinessContent: unlockBusinessContent
                }
            })
        ]
    });
}


/***/ }),

/***/ 54531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gr": function() { return /* binding */ getUrl; },
/* harmony export */   "L0": function() { return /* binding */ getFormattedDate; },
/* harmony export */   "U8": function() { return /* binding */ getKeyWordsForMetaTags; },
/* harmony export */   "Z5": function() { return /* binding */ getMetaTitleDescriptionForPage; },
/* harmony export */   "_7": function() { return /* binding */ getDescriptionForPostByID; },
/* harmony export */   "_H": function() { return /* binding */ getMainTitlesNavigationFromBody; },
/* harmony export */   "fH": function() { return /* binding */ getFinalLogosForLogoSLider; },
/* harmony export */   "fx": function() { return /* binding */ getDescriptionForHomePage; },
/* harmony export */   "nn": function() { return /* binding */ addStyleClassToIframe; },
/* harmony export */   "qp": function() { return /* binding */ getKeyWordsForPostByID; },
/* harmony export */   "yV": function() { return /* binding */ addStyleClassToTable; }
/* harmony export */ });
/* unused harmony export extractExcerptFromBody */
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75094);

const getUrl = (pathname = "")=>{
    return `${window.location.origin}${pathname}`;
};
const getMainTitlesNavigationFromBody = (html)=>{
    const regex = /<[^>]+ id="([^"]+)"[^>]*>([\s\S]+?)<\/[^>]+>/g;
    const result = [];
    let match;
    while(match = regex.exec(html)){
        const [, id, content] = match;
        const textNodes = content.match(/>([^<]+)/g);
        if (textNodes) {
            result.push(// eslint-disable-next-line no-unsafe-optional-chaining
            ...textNodes?.map((node)=>({
                    value: node.substring(1).trim(),
                    id
                })));
        } else {
            result.push({
                value: content.trim(),
                id
            });
        }
    }
    return result.filter((i)=>i.value?.length > 1).map((el)=>({
            title: /^\d/.test(el.value) ? el.value.replace(/^\d/, "").slice(1) : el.value,
            link: `#${el.id}`
        }));
};
const addStyleClassToTable = (body)=>{
    if (body) {
        // start tag replace with <div className="table-responsive" > <table
        const firstSectionStartTag = body?.split("<table")[0]; // first section dose not contain <table to replace
        const bodyAfterReplaceStartTag = body?.split("<table").slice(1).map((table)=>{
            return `<div class="table-responsive"> <table ${table}`;
        });
        // final body after replace start tag
        const bodyAfterAddingStartTag = [
            firstSectionStartTag,
            ...bodyAfterReplaceStartTag, 
        ].join(" ");
        // end tag replace with </table> </div>
        const firstSectionEndTag = bodyAfterAddingStartTag.split("</table>")[0];
        const bodyAfterReplaceEndTag = bodyAfterAddingStartTag.split("</table>").slice(1).map((table)=>{
            return `</table></div>${table}`;
        });
        // final body after replace
        const finalBody = [
            firstSectionEndTag,
            ...bodyAfterReplaceEndTag
        ].join(" ");
        return finalBody;
    } else {
        return body;
    }
};
const addStyleClassToIframe = (body)=>{
    if (body) {
        // start tag replace with <div className="iframe-responsive" > <iframe
        const firstSectionStartTag = body?.split("<iframe")[0]; // first section dose not contain <iframe to replace
        const bodyAfterReplaceStartTag = body?.split("<iframe").slice(1).map((iframe)=>{
            return `<div class="iframe-responsive"> <iframe ${iframe}`;
        });
        // final body after replace start tag
        const bodyAfterAddingStartTag = [
            firstSectionStartTag,
            ...bodyAfterReplaceStartTag, 
        ].join(" ");
        // end tag replace with </iframe> </div>
        const firstSectionEndTag = bodyAfterAddingStartTag.split("</iframe>")[0];
        const bodyAfterReplaceEndTag = bodyAfterAddingStartTag.split("</iframe>").slice(1).map((iframe)=>{
            return `</iframe></div>${iframe}`;
        });
        // final body after replace
        const finalBody = [
            firstSectionEndTag,
            ...bodyAfterReplaceEndTag
        ].join(" ");
        return finalBody;
    } else {
        return body;
    }
};
const getFormattedDate = (date)=>{
    const regex = /^[0-9]+$/; //check if the string contain only numeric characters(time stamp)
    return new Date(regex.test(date) ? +date : date).toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
};
const extractExcerptFromBody = (body, characters)=>{
    return body.replace(/<[^>]+>/g, "").substring(0, characters).trim();
};
const getDescriptionForPostByID = (post)=>{
    if (post && post?.metatags && post?.metatags?.length) {
        for(let i = 0; i < post?.metatags.length; i++){
            if (post.metatags[i]?.key === "description" && post.metatags[i]?.value) {
                return post?.metatags[i]?.value;
            }
        }
    }
    if (post?.excerpt) {
        return extractExcerptFromBody((0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__/* .replacePlaceholders */ .wT)(post.excerpt, {
            category: post?.category?.label ?? post?.category?.name
        }), 160);
    }
    if (post?.body) {
        return extractExcerptFromBody((0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__/* .replacePlaceholders */ .wT)(post.body, {
            category: post?.category?.label ?? post?.category?.name
        }), 160);
    }
    return "Several Brands LLC is a Performance Marketer Firm. We generate leads, calls and live transfers for local businesses. Furthermore, we promote various products from several affiliate networks.";
};
const getKeyWordsForPostByID = (post, domainInfo)=>{
    if (post && post?.metatags && post?.metatags?.length) {
        for(let i = 0; i < post?.metatags.length; i++){
            if (post?.metatags[i]?.key === "keywords" && post?.metatags[i]?.value) {
                return post?.metatags[i]?.value;
            }
        }
    }
    if (post?.tags) {
        return post?.tags?.map((tag)=>tag?.name).join(",");
    }
    for(let i1 = 0; i1 < (domainInfo?.metatags.length ?? 0); i1++){
        if (domainInfo?.metatags[i1]?.key === "keywords" && domainInfo?.metatags[i1]?.value) {
            return domainInfo?.metatags[i1]?.value;
        }
    }
    return "";
};
const getDescriptionForHomePage = (domain)=>{
    if (domain && domain?.metatags && domain?.metatags?.length) {
        for(let i = 0; i < (domain?.metatags?.length ?? 0); i++){
            if (domain?.metatags[i]?.key === "extra-meta-HomePage-meta-description" && domain?.metatags[i]?.value) {
                return domain?.metatags[i]?.value;
            }
        }
    }
    if (domain?.description) {
        return domain.description.replace(/<[^>]+>/g, "");
    }
    return "Several Brands LLC is a Performance Marketer Firm. We generate leads, calls and live transfers for local businesses. Furthermore, we promote various products from several affiliate networks.";
};
const getKeyWordsForMetaTags = (domain)=>{
    if (domain && domain?.metatags && domain?.metatags?.length) {
        for(let i = 0; i < (domain?.metatags?.length ?? 0); i++){
            if (domain?.metatags[i]?.key === "keywords" && domain?.metatags[i]?.value) {
                return domain?.metatags[i]?.value;
            }
        }
    }
    return "";
};
const getMetaTitleDescriptionForPage = (domain, keyPage)=>{
    if (domain && domain?.metatags && domain?.metatags?.length) {
        return {
            title: domain?.metatags.find((metaTag)=>metaTag.key === `extra-meta-${keyPage}-meta-title`)?.value,
            description: domain?.metatags.find((metaTag)=>metaTag.key === `extra-meta-${keyPage}-meta-description`)?.value
        };
    }
};
const getFinalLogosForLogoSLider = (featuredList, categorySlug)=>{
    const finalLogos = featuredList ? categorySlug ? featuredList[categorySlug] : featuredList["default"] : [];
    return finalLogos;
};


/***/ }),

/***/ 71391:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","scrolled":"style_scrolled__fS6VT","scrolled__inner":"style_scrolled__inner__gigDt","scroll":"style_scroll__sLdOC"};

/***/ })

}]);